/**
 * Defines color scheme for using with surface items
 */
export interface ColorScheme {
    /**
     * The css color for accessible text on a schemePrimary background
     * DEPRECATED, will be removed in future version. Use accessibleText.schemePrimaryBackground instead
     */
    text: string;

    /**
     * The css color for accessible text on a schemeLighter background
     * DEPRECATED, will be removed in future version. Use accessibleText.schemeLighterBackground instead
     */
    textAlt: string;

    schemeDarker: string;
    schemeDark: string;
    schemeDarkAlt: string;
    schemePrimary: string;
    schemeSecondary: string;
    schemeTertiary: string;
    schemeLight: string;
    schemeLighter: string;
    schemeLighterAlt: string;
    colorName: () => string;

    /**
     * The css color for accessible test on the given backgrounds
     */
    accessibleText?: AccessibleTextScheme;
}

export interface AccessibleTextScheme {
    schemePrimaryBackground: string;
    schemeLighterBackground: string;
    msColorWhiteBackground: string;
    msColorNeutralLighterBackground: string;
}

export enum AccessibleTextSchemeBackground {
    schemePrimary,
    schemeLighter,
    msColorWhite,
    msColorNeutralLighter,
}
